import React from 'react';
import {connect} from 'react-redux';
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import css from './LayersPanel.module.css';
import * as filterActions from '../../../../store/filterSlice';
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import {GymMembershipTypes} from "../../../../store/filterSlice";
import {setShowDefenders} from "../../../../store/defenderSlice";

const GymControls = (props) => {
	const onClickGoldBadgeTracker = () => {
		window.location.href = "https://www.a2pogo.com/mod/pokemon/map/gold.php";
	};
	const onClickGymMembership = () => {
		props.setShowDefenders(true);
	};

	const onChangeGymBadge = (event) => {
		props.setGoldBadge(event.target.value);
	};

	const onChangeGymTeam = (event) => {
		props.setGymTeam(event.target.value);
	};
	const onChangeGymStagnationDays = (event) => {
		props.setGymStagnationDays(event.target.value);
	};
	const onChangeGymMembership = (event) => {
		props.setGymMembership(event.target.value);
	};
	const onChangeGymOpenSpotsOnly = (event) => {
		props.toggleFeature('gymOpenSpotsOnly');
	};

	const onChangeGymExFilter = (event) => {
		props.toggleFeature('gymExFilter');
	};

	return (
		<div className={css.Panel}>
			<div className={css.Title}>
				<span style={{flexGrow: 1}}>Gyms</span>
				<Button onClick={onClickGoldBadgeTracker} variant='contained' className={css.BadgeTrackerButton}>Badge Tracker</Button>
				<Button onClick={onClickGymMembership} variant='contained' className={css.BadgeTrackerButton}>Your Defenders</Button>
			</div>

			{props.discordUser &&
			<FormControl className={css.FormElement}>
				<InputLabel>Gold Badge Status</InputLabel>

				<Select value={props.gymBadge} onChange={onChangeGymBadge}>
					<MenuItem value="0">Gold & Not Gold</MenuItem>
					<MenuItem value="1">Not Gold</MenuItem>
					<MenuItem value="2">Have Gold</MenuItem>
				</Select>
			</FormControl>
			}

			<FormControl className={css.FormElement}>
				<InputLabel>Current Team</InputLabel>

				<Select value={props.gymTeam} onChange={onChangeGymTeam}>
					<MenuItem value="0">All Teams</MenuItem>
					<MenuItem value="1">Mystic</MenuItem>
					<MenuItem value="2">Valor</MenuItem>
					<MenuItem value="3">Instinct</MenuItem>
				</Select>
			</FormControl>

			{props.isAdmin && 1===0 &&
			<FormControl className={css.FormElement}>
				<InputLabel>Stagnation</InputLabel>

				<Select value={props.gymStagnationDays} onChange={onChangeGymStagnationDays}>
					<MenuItem value="0">All</MenuItem>
					<MenuItem value="1">Day</MenuItem>
					<MenuItem value="7">Week</MenuItem>
					<MenuItem value="14">Fortnight</MenuItem>
					<MenuItem value="30">Month</MenuItem>
					<MenuItem value="90">3 Months</MenuItem>
					<MenuItem value="180">6 Months</MenuItem>
					<MenuItem value="365">Year</MenuItem>
				</Select>
			</FormControl>
			}

			{props.isAdmin &&
				<FormControl className={css.FormElement}>
					<InputLabel>Membership</InputLabel>

					<Select value={props.gymMembership} onChange={onChangeGymMembership}>
						<MenuItem value={GymMembershipTypes.ALL}>All</MenuItem>
						<MenuItem value={GymMembershipTypes.AM_MEMBER}>Am Member</MenuItem>
						<MenuItem value={GymMembershipTypes.AM_NOT_MEMBER}>Am Not Member</MenuItem>
					</Select>
				</FormControl>
			}

			<FormControl className={css.FormElement}>
				<FormControlLabel control={(
					<Checkbox
						checked={props.gymOpenSpotsOnly}
						onChange={onChangeGymOpenSpotsOnly}
					/>
				)} label='Only Gyms With Open Spots' />
			</FormControl>

			<FormControl className={css.FormElement}>
				<FormControlLabel control={(
					<Checkbox
						checked={props.gymExFilter}
						onChange={onChangeGymExFilter}
					/>
				)} label='Only EX-Eligible Gyms' />
			</FormControl>


		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		// NAME: state.NAME
		discordUser: state.core.discordUser,
		gymBadge: state.filter.goldBadge,
		gymTeam: state.filter.gymTeam,
		gymStagnationDays: state.filter.gymStagnationDays,
		gymMembership: state.filter.gymMembership,
		gymExFilter: state.filter.gymExFilter,
		gymOpenSpotsOnly: state.filter.gymOpenSpotsOnly,
		isAdmin: state.core.isAdmin
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setGoldBadge: (val) => dispatch(filterActions.setGoldBadge(val)),
		setShowDefenders: (val) => dispatch(setShowDefenders(val)),
		setGymTeam: (val) => dispatch(filterActions.setGymTeam(val)),
		setGymStagnationDays: (val) => dispatch(filterActions.setGymStagnationDays(val)),
		setGymMembership: (val) => dispatch(filterActions.setGymMembership(val)),
		toggleFeature: (val) => dispatch(filterActions.toggleFeature(val)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(GymControls);